import { motion } from "framer-motion";
import { STEPS } from "@/data/site";
import { Reveal, SectionLabel } from "./Reveal";

export const HowToBuy = () => (
  <section id="how-to-buy" className="relative bg-[#0b0f18] py-24 sm:py-36" data-testid="how-to-buy-section">
    <div className="absolute right-0 top-0 h-[400px] w-[400px] rounded-full bg-teal-500/10 blur-[120px]" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
        <div>
          <Reveal><SectionLabel index="02">Acquisition protocol</SectionLabel></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display text-4xl font-bold uppercase leading-[0.95] sm:text-6xl">
              How to join <br /><span className="text-gold">upper management</span>
            </h2>
          </Reveal>
        </div>
      </div>
      <div className="mt-16 grid gap-px bg-teal-400/15 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.1} className="bg-[#0b0f18]">
            <motion.div whileHover={{ y: -6 }} transition={{ type: "spring", stiffness: 260, damping: 20 }}
              className="group relative h-full p-8" data-testid={`step-card-${i + 1}`}>
              <span className="absolute inset-x-0 top-0 h-px origin-left scale-x-0 bg-amber-400 transition-transform duration-500 group-hover:scale-x-100" />
              <p className="font-display text-6xl font-black text-outline transition-colors duration-500 group-hover:text-amber-400">{s.n}</p>
              <h3 className="mt-8 font-display text-xl font-bold text-slate-50">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">{s.text}</p>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
